/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface PhoneCsvPostAssertErrorResponse
 */
export interface PhoneCsvPostAssertErrorResponse {
  /**
   * A display string for the error
   * @type {string}
   * @memberof PhoneCsvPostAssertErrorResponse
   */
  error: string;
  /**
   * HTTP status code in the body
   * @type {number}
   * @memberof PhoneCsvPostAssertErrorResponse
   */
  status?: number;
  /**
   * enum error type string to make a condition on
   * @type {string}
   * @memberof PhoneCsvPostAssertErrorResponse
   */
  type: PhoneCsvPostAssertErrorResponseTypeEnum;
}

/**
 * @export
 */
export const PhoneCsvPostAssertErrorResponseTypeEnum = {
  CsvEmpty: 'csv_empty',
  PhoneColumnRequired: 'phone_column_required',
} as const;
export type PhoneCsvPostAssertErrorResponseTypeEnum =
  (typeof PhoneCsvPostAssertErrorResponseTypeEnum)[keyof typeof PhoneCsvPostAssertErrorResponseTypeEnum];

/**
 * Check if a given object implements the PhoneCsvPostAssertErrorResponse interface.
 */
export function instanceOfPhoneCsvPostAssertErrorResponse(
  value: object,
): value is PhoneCsvPostAssertErrorResponse {
  if (!('error' in value) || value['error'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function PhoneCsvPostAssertErrorResponseFromJSON(
  json: any,
): PhoneCsvPostAssertErrorResponse {
  return PhoneCsvPostAssertErrorResponseFromJSONTyped(json, false);
}

export function PhoneCsvPostAssertErrorResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PhoneCsvPostAssertErrorResponse {
  if (json == null) {
    return json;
  }
  return {
    error: json['error'],
    status: json['status'] == null ? undefined : json['status'],
    type: json['type'],
  };
}

export function PhoneCsvPostAssertErrorResponseToJSON(
  value?: PhoneCsvPostAssertErrorResponse | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    error: value['error'],
    status: value['status'],
    type: value['type'],
  };
}
